<template>
  <div class="bg-gray-100 dark-bg-default pb-8">
    <div
      class="sticky flex top-0 justify-end z-50 bg-[#f3f4f6] dark-bg-custom py-4"
    >
      <div class="flex justify-between">
        <h4 class="text-lg font-semibold ml-5">Case Details</h4>
        <h4 class="text-md font-semibold mr-5">
          Case Status -
          <v-chip
            label
            :text-color="statusColor(selectedCase?.status)?.textColor"
            :color="statusColor(selectedCase?.status)?.bgColor"
          >
            {{ selectedCase?.status }}
          </v-chip>
        </h4>
      </div>
      <v-btn plain @click="closeDialog">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div>
      <div class="text-sm my-3 mx-6 px-4 py-4">
        <v-row>
          <v-col class="px-4 py-1" cols="2"><strong>Case No</strong></v-col>
          <v-col class="px-4 py-1">{{ selectedCase.caseNo }}</v-col>
        </v-row>
        <v-row v-if="selectedCase?.userDefinedCaseStatus">
          <v-col class="px-4 py-1" cols="2"
            ><strong>Case Outcome</strong></v-col
          >
          <v-col class="px-4 py-1">{{
            selectedCase?.userDefinedCaseStatus
          }}</v-col>
        </v-row>
        <v-row v-if="selectedCase.customer?.customerFullName">
          <v-col class="px-4 py-1" cols="2"
            ><strong>Customer Name</strong></v-col
          >
          <v-col class="px-4 py-1">
            {{ selectedCase.customer?.customerFullName }}
          </v-col>
        </v-row>
        <v-row v-if="selectedCase.customer?.customerAddress?.length">
          <v-col class="px-4 py-1" cols="2"
            ><strong>Customer Address</strong></v-col
          >
          <v-col class="px-4 py-1">
            {{
              customerAddress(selectedCase.customer?.customerAddress[0]) || "-"
            }}
          </v-col>
        </v-row>
        <v-row v-if="selectedCase.caseStartDate">
          <v-col class="px-4 py-1" cols="2"
            ><strong>Case Start Date</strong></v-col
          >
          <v-col class="px-4 py-1">{{
            selectedCase.caseStartDate
              ? $dayjs(selectedCase.caseStartDate).format("DD/MM/YYYY hh:mm A")
              : ""
          }}</v-col>
        </v-row>
        <v-row v-if="selectedCase.caseEndDate">
          <v-col class="px-4 py-1" cols="2"
            ><strong>Case End Date</strong></v-col
          >
          <v-col class="px-4 py-1">{{
            selectedCase.caseEndDate
              ? $dayjs(selectedCase.caseEndDate).format("DD/MM/YYYY hh:mm A")
              : ""
          }}</v-col>
        </v-row>
        <v-row v-if="selectedCase.caseEndDate">
          <v-col class="px-4 py-1" cols="2"><strong>TAT</strong></v-col>
          <v-col class="px-4 py-1">{{ calculateTAT(selectedCase) }}</v-col>
        </v-row>
        <v-row v-for="(column, i) in additionalColums" :key="i">
          <v-col class="px-4 py-1" cols="2" v-show="column.value"
            ><strong>{{ convertToTitle(column?.key) || "" }}</strong></v-col
          >
          <v-col class="px-4 py-1" v-if="column.fieldType === 'DATE'">
            {{ column.value ? $dayjs(column.value).format("DD-MM-YYYY") : "" }}
          </v-col>
          <v-col class="px-4 py-1" v-show="column.value" v-else>{{
            column.value
          }}</v-col>
        </v-row>
        <v-row v-if="selectedCase?.productInfo">
          <v-col class="px-4 py-2" cols="2"
            ><strong>{{ configLang.productInfo?.displayName }}</strong></v-col
          >
          <v-col class="px-4 py-2">
            {{ selectedCase?.productInfo }}
          </v-col>
        </v-row>
      </div>
    </div>
    <hr />
    <h4 class="text-lg font-semibold ml-5 mt-4 mb-4 py-2">Visit Details</h4>

    <div class="mx-10" v-if="selectedCase.tasks.length">
      <!-- Pending Visits -->
      <div v-if="pendingVisits && pendingVisits.length">
        <div class="flex gap-5 items-center">
          <v-divider></v-divider>
          <h5 class="text-md font-semibold ml-2 mb-2">[ Upcomming Visits ]</h5>
          <v-divider></v-divider>
        </div>

        <v-expansion-panels v-model="pendingPanel" flat>
          <v-row class="text-center px-8 dark-bg-custom">
            <v-col class="mt-4 font-semibold px-0">Visit/Calls</v-col>
            <v-col class="mt-4 font-semibold px-0">Visit Details</v-col>
            <v-col
              class="mt-4 font-semibold px-0"
              v-if="isCallEnabled('CALL_A_CUSTOMER')"
              >Call Frequency</v-col
            >
            <v-col class="mt-4 font-semibold px-0">Outcome</v-col>
            <v-col class="mt-4 font-semibold px-0">Next Scheduled</v-col>
            <v-col class="mt-4 font-semibold px-0">Status</v-col>
          </v-row>
          <v-expansion-panel
            v-for="(task, index) in pendingVisits"
            :key="'pending-' + index"
            class="mt-3"
          >
            <v-expansion-panel-header class="pt-0 pb-0 penel_header px-2">
              <div class="flex justify-between align-center w-full">
                <v-row class="text-center">
                  <v-col>
                    <p class="text-base font-semibold mt-5">
                      {{ pendingVisits.length - index }}
                    </p>
                  </v-col>
                  <v-col>
                    <p class="mt-5 font-semibold text-blue-600">
                      {{ selectedCase.caseNo }}
                    </p>
                  </v-col>
                  <v-col v-if="isCallEnabled('CALL_A_CUSTOMER')">
                    <p class="mt-5 font-semibold">
                      {{
                        Array.isArray(task.callInfo) ? task.callInfo.length : 0
                      }}
                    </p>
                  </v-col>
                  <v-col>
                    <p class="mt-5 font-semibold">
                      {{ task.meetingDetails?.meetingOutCome }}
                    </p>
                  </v-col>
                  <v-col>
                    <p class="mt-5 font-semibold">
                      {{
                        task.meetingDetails?.nextTaskScheduledOn
                          ? $dayjs(
                              task.meetingDetails?.nextTaskScheduledOn
                            ).format("DD/MM/YYYY hh:mm A")
                          : $dayjs(task.taskStartDateTime).format(
                              "DD/MM/YYYY hh:mm A"
                            )
                      }}
                    </p>
                  </v-col>
                  <v-col>
                    <v-chip
                      small
                      label
                      class="mt-5 font-semibold"
                      :text-color="statusColor(task.taskStatus).textColor"
                      :color="statusColor(task.taskStatus).bgColor"
                      >{{ task.taskStatus }}</v-chip
                    >
                  </v-col>
                </v-row>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="text-sm">
              <CaseTaskData
                :task="taskData(task)"
                :key="task._id"
                :type="type"
                :caseConfig="caseConfig"
                @deleteTask="handleDeleteTask"
                :callTab="callTab"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
      <no-data
        v-else
        title="No Upcoming Visits"
        :subTitle="`Start by adding visits`"
        :btnText="'Add Visit'"
        :btnAction="addVisit"
        :callTab="callTab"
      />

      <!-- Other Visits -->
      <div v-if="otherVisits && otherVisits.length">
        <div class="flex gap-5 items-center my-6">
          <v-divider></v-divider>
          <h5 class="text-md font-semibold ml-2 mb-2">[ Older Visits ]</h5>
          <v-divider></v-divider>
        </div>

        <v-expansion-panels v-model="otherPanel" flat>
          <v-row class="text-center px-8 dark-bg-custom">
            <v-col class="mt-4 font-semibold px-0">Visit/Calls</v-col>
            <v-col class="mt-4 font-semibold px-0">Visit Details</v-col>
            <v-col
              class="mt-4 font-semibold px-0"
              v-if="isCallEnabled('CALL_A_CUSTOMER')"
              >Call Frequency</v-col
            >
            <v-col class="mt-4 font-semibold px-0">Outcome</v-col>
            <v-col class="mt-4 font-semibold px-0">Last Scheduled</v-col>
            <v-col class="mt-4 font-semibold px-0">Status</v-col>
          </v-row>
          <v-expansion-panel
            v-for="(task, index) in otherVisits"
            :key="'other-' + index"
            class="mt-3"
          >
            <v-expansion-panel-header class="pt-0 pb-0 penel_header px-2">
              <div class="flex justify-between align-center w-full">
                <v-row class="text-center">
                  <v-col>
                    <p class="text-base font-semibold mt-5">
                      {{ otherVisits.length - index }}
                    </p>
                  </v-col>
                  <v-col>
                    <p class="mt-5 font-semibold text-blue-600">
                      {{ selectedCase.caseNo }}
                    </p>
                  </v-col>
                  <v-col v-if="isCallEnabled('CALL_A_CUSTOMER')">
                    <p class="mt-5 font-semibold">
                      {{
                        Array.isArray(task.callInfo) ? task.callInfo.length : 0
                      }}
                    </p>
                  </v-col>
                  <v-col>
                    <p class="mt-5 font-semibold">
                      {{ task.meetingDetails?.meetingOutCome }}
                    </p>
                  </v-col>
                  <v-col>
                    <p class="mt-5 font-semibold">
                      {{
                        task.meetingDetails?.nextTaskScheduledOn
                          ? $dayjs(
                              task.meetingDetails?.nextTaskScheduledOn
                            ).format("DD/MM/YYYY hh:mm A")
                          : ""
                      }}
                    </p>
                  </v-col>
                  <v-col>
                    <v-chip
                      small
                      label
                      class="mt-5 font-semibold"
                      :text-color="statusColor(task.taskStatus).textColor"
                      :color="statusColor(task.taskStatus).bgColor"
                      >{{ task.taskStatus }}</v-chip
                    >
                  </v-col>
                </v-row>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="text-sm">
              <CaseTaskData
                :task="taskData(task)"
                :key="task._id"
                :type="type"
                :caseConfig="caseConfig"
                @deleteTask="handleDeleteTask"
                :callTab="callTab"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </div>
    </div>
    <no-data
      v-else
      title="Nothing to Display"
      :subTitle="`Start by adding visits`"
      :btnText="'Add Visit'"
      :btnAction="addVisit"
      :callTab="callTab"
    />
    <v-dialog v-model="openAddVisit" max-width="600">
      <AddEditCaseTask
        :caseConfig="caseConfig"
        :editCase="selectedCase"
        @newTaskAdded="handleAdded"
        @caseTaskAdded="cancelVisit"
      />
    </v-dialog>
  </div>
</template>
<script>
import NoData from "@/components/NoData.vue";
import CaseTaskData from "./CaseTaskData";
import AddEditCaseTask from "./AddEditCaseTask";
import {
  convertToTitleCase,
  getFullAddress,
  fullName,
  dayHourFormat,
  isModuleFeatureAllowed,
} from "@/utils/common";
import { orderStatusColors } from "@/utils/workforce/statusColors";
export default {
  name: "CaseDetails",
  data() {
    return {
      panel: 0,
      type: "visitDetails",
      openAddVisit: false,
      pendingPanel: 0,
      otherPanel: 0,
    };
  },
  components: { NoData, CaseTaskData, AddEditCaseTask },
  props: {
    selectedCase: Object,
    caseConfig: Object,
    callTab: Boolean,
  },
  watch: {
    selectedCase: {
      handler(newVal) {
        this.selectedCase = newVal;
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    additionalColums() {
      if (this.selectedCase?.additionalColumns) {
        const addCol = this.$props.caseConfig?.additionalColumns;
        const newColumns = Object.entries(
          this.selectedCase?.additionalColumns
        )?.map(([key, obj]) => {
          const fieldType = addCol?.[key].fieldType;
          return {
            key,
            value: obj,
            fieldType,
          };
        });
        return newColumns;
      }
      return [];
    },
    configLang() {
      return this.$props.caseConfig?.fieldMappings;
    },
    pendingVisits() {
      return this.selectedCase.tasks?.filter((task) => {
        const taskDate = task?.taskStartDateTime
          ? this.$dayjs(task.taskStartDateTime)
          : null;
        return (
          taskDate &&
          (taskDate.isSame(this.$dayjs(), "day") ||
            taskDate.isAfter(this.$dayjs()))
        );
      });
    },
    otherVisits() {
      return this.selectedCase.tasks?.filter((task) => {
        const taskDate = task?.taskStartDateTime
          ? this.$dayjs(task.taskStartDateTime)
          : null;
        return taskDate && taskDate.isBefore(this.$dayjs(), "day");
      });
    },
  },
  methods: {
    isCallEnabled(feature) {
      return isModuleFeatureAllowed("ADDONS", feature);
    },
    taskData(task) {
      const newTask = {
        ...task,
        case: {
          caseNo: this.selectedCase.caseNo,
          customerName: this.selectedCase.customer?.customerFullName,
          caseStatus: this.selectedCase?.userDefinedCaseStatus,
        },
      };
      return newTask;
    },
    calculateTAT(item) {
      const caseStart = item.caseStartDate;
      const caseEnd = item.caseEndDate;
      if (caseEnd) {
        return dayHourFormat(caseStart, caseEnd);
      }
      return "-";
    },
    async handleDeleteTask(item) {
      try {
        const response = await this.$axios.delete(
          `/workforce/collection/case/task/${item._id}`
        );
        const index = this.selectedCase?.tasks.findIndex(
          (task) => task._id === item._id
        );
        if (index !== -1) {
          this.selectedCase?.tasks.splice(index, 1);
        }
        const successMessage =
          response?.data?.message || "Case task deleted successfully.";
        this.$toast.success(successMessage);
      } catch (error) {
        const errorMessage =
          error?.response?.data?.message ||
          "An error occurred while deleting the case task.";
        this.$toast.error(errorMessage);
        console.error(error);
      }
    },
    convertToTitle(str) {
      return convertToTitleCase(str);
    },
    statusColor(status) {
      const colorInfo = orderStatusColors[status];
      return colorInfo;
    },
    customerAddress(item) {
      return getFullAddress(item);
    },
    customerName(item) {
      if (item) {
        return fullName(item);
      }
    },
    addVisit() {
      this.openAddVisit = true;
    },
    cancelVisit() {
      this.openAddVisit = false;
    },
    handleAdded(task) {
      this.openAddVisit = false;
      this.selectedCase.tasks.push(task);
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>
<style scoped>
.penel_header {
  border-bottom: 1px solid rgb(192, 189, 189);
}
</style>
